<template>
  <div class="chart-container">
    <div
      :id="chartId"
      :style="{ height: `${height}px`, width: width ? `${width}px` : 'auto' }"
      @click="onClick"
    ></div>
  </div>
</template>

<script>
import {
  addResizeListener,
  removeResizeListener
} from 'element-ui/src/utils/resize-event'
import merge from 'lodash.merge'
import echarts from 'echarts'
import { debounce } from '@/utlis'
require('echarts/theme/macarons') // echarts theme

const DEFAULT_OPTION = {
  title: {},
  legend: {},
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: { backgroundColor: '#6a7985' }
    }
  },
  toolbox: {
    feature: {}
  },
  grid: {
    top: '14%',
    left: '5%',
    right: '6%',
    bottom: '3%',
    containLabel: true
  },
  series: []
}

export default {
  props: {
    chartId: { type: String, default: 'chart', required: true },
    options: {
      type: Object,
      default() {
        return DEFAULT_OPTION
      }
    },
    height: {
      type: Number,
      default: 500
    },
    width: Number,
    notMerge: { type: Boolean, default: false }
  },
  data() {
    return {
      chart: null,
      resizeHandler: null,
      dataIndex: -1
    }
  },
  render(h) {
    return h('div', {
      attrs: {
        id: this.chartId,
        style: this.layout
      }
    })
  },
  mounted() {
    this.chart = echarts.init(document.getElementById(this.chartId), 'macarons')
    this.chart.setOption(merge({}, DEFAULT_OPTION, this.options), {
      notMerge: this.notMerge
    })
    this.resizeHandler = debounce(() => {
      this.chart && this.chart.resize()
    }, 200)
    addResizeListener(this.$el, this.resizeHandler)
    this.chart.on('updateAxisPointer', e => {
      this.dataIndex = e.dataIndex
      this.$emit('update-axis-pointer', e)
    })
  },
  beforeDestroy() {
    this.chart && this.chart.clear()
    removeResizeListener(this.$el, this.resizeHandler)
  },
  methods: {
    init(opt) {
      this.chart.setOption(opt)
    },
    select(name) {
      this.chart.dispatchAction({ type: 'legendAllSelect' })
      if (name) {
        this.chart.dispatchAction({ type: 'legendInverseSelect' })
        this.chart.dispatchAction({ type: 'legendSelect', name })
      }
    },
    selectAll() {
      this.chart.dispatchAction({ type: 'legendAllSelect' })
    },
    inverseSelect() {
      this.chart.dispatchAction({ type: 'legendInverseSelect' })
    },
    selectToggle(name) {
      this.chart.dispatchAction({ type: 'legendToggleSelect', name })
    },
    onClick() {
      this.$emit('lock', this.dataIndex)
    }
  },
  watch: {
    options(o) {
      this.chart &&
        this.chart.setOption(merge({}, DEFAULT_OPTION, o), {
          notMerge: this.notMerge
        })
    }
  }
}
</script>

<style lang="css" scoped></style>
